export default __webpack_public_path__ + "04fa6a0bc5950e94cf66eb423d3dd45a.png";